import { adminEventService } from "@/services/admin_event.service";
import { useQuery } from "@tanstack/react-query";

export const useGetAllAdminEvents = (pageNumber: number) => {
    const { data, isLoading, isError, error, refetch, isPending } = useQuery({
        queryKey: ['adminEvent', pageNumber],
        queryFn: () => adminEventService.getAllAdminEvents(pageNumber),
    });
    return {
        events: data?.data ?? [],
        totalPages: data?.pageCount,
        isLoading,
        isError,
        error,
        refetch,
        isPending,
    };
};
